import { render, staticRenderFns } from "./LongTextPopup.vue?vue&type=template&id=119d8a15&scoped=true&"
import script from "./LongTextPopup.vue?vue&type=script&lang=js&"
export * from "./LongTextPopup.vue?vue&type=script&lang=js&"
import style0 from "./LongTextPopup.vue?vue&type=style&index=0&id=119d8a15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119d8a15",
  null
  
)

export default component.exports